import React, {Component} from "react";
import {Layout, Space, Table, Typography} from "antd";
import {DataTypes} from "../../data/types";
import {
    EditOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import {amIAdmin} from "../../helpers/auth";

const {Content} = Layout;

class CategoriesContainer extends Component {
    state = {}

    componentDidMount() {

    }

    onChange = (pagination, filters, sorter, extra) => {
        //console.log('change params', pagination, filters, sorter, extra);
        if (extra.action === 'paginate') {
            const params = {
                ...this.props[`${DataTypes.CATEGORIES}_params`],
                page: pagination.current,
                limit: pagination.pageSize
            };
            this.props.loadCollection(DataTypes.CATEGORIES, params, this.props.history);
        } else if (extra.action === 'sort') {
            const params = {
                ...this.props[`${DataTypes.CATEGORIES}_params`],
                sort: sorter.column ? {column: sorter.column.dataIndex, order: sorter.order} : null
            };
            this.props.loadCollection(DataTypes.CATEGORIES, params, this.props.history);
        }
    }

    render() {
        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                sorter: true,
                width: 70,
            },
            {
                title: 'Nazwa kategorii',
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                defaultSortOrder: 'ascend',
                width: 190,
            },
            {
                title: 'Opis',
                dataIndex: 'description',
                key: 'description',
                sorter: true
            },
            {
                title: 'Akcje',
                key: 'actions',
                fixed: 'right',
                width: 100,
                render: () => amIAdmin() ? <Space>
                    <Typography.Link>
                        <EditOutlined title={'Edytuj'}/>
                    </Typography.Link>
                    <Typography.Link>
                        <DeleteOutlined title={'Usuń'}/>
                    </Typography.Link>
                </Space> : null,
            }
        ];

        return <Layout style={{padding: '0 24px 24px'}}>
            <Content style={{
                background: '#fff',
                padding: 24,
                margin: 0,
            }}>
                <div className="site-card-wrapper">
                    <Table
                        size="small"
                        columns={columns}
                        dataSource={this.props.categories}
                        rowKey={'id'}
                        pagination={{
                            total: this.props.categories_total,
                            current: this.props.categories_params.page,
                            pageSize: this.props.categories_params.limit,
                            pageSizeOptions: ['10', '20', '50'],
                            showSizeChanger: true,
                            showQuickJumper: false,
                            //showTotal: this.showTotalItemsDialog,
                        }}
                        onChange={this.onChange}
                    />
                </div>
            </Content>
        </Layout>;
    }
}

export default CategoriesContainer;
